import Spinner from '@atlaskit/spinner';

import * as styles from './transparent-loading-cover.styled';

const TransparentLoadingCover = () => {
  return (
    <styles.Loader data-testid="transparent-loading-cover">
      <Spinner testId="spinner" />
    </styles.Loader>
  );
};

export default TransparentLoadingCover;
